import { createQueryKeys } from '../../factories';
import { RESOURCE_CATALOG_NAMESPACE } from './constants.ns';

export const resourceCatalogQueryKeyFactory = createQueryKeys(
	RESOURCE_CATALOG_NAMESPACE
);
